import { Link } from 'react-router-dom';

export const SectionHeader = ({ eyebrow, title, subtitle, action, actionTo, testId }) => (
  <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10" data-testid={testId}>
    <div className="max-w-2xl">
      {eyebrow && <div className="sc-mono-eyebrow mb-3 text-amber-500">{eyebrow}</div>}
      <h2 className="text-3xl md:text-4xl font-bold text-white tracking-tight leading-[1.15]" style={{ fontFamily: 'Outfit, sans-serif' }}>
        {title}
      </h2>
      {subtitle && <p className="mt-3 text-slate-400 text-base leading-relaxed">{subtitle}</p>}
    </div>
    {action && actionTo && (
      <Link to={actionTo} className="group text-sm font-mono uppercase tracking-wider text-amber-500 hover:text-amber-400 flex items-center gap-2 shrink-0">
        {action}
        <span className="group-hover:translate-x-1 transition-transform">→</span>
      </Link>
    )}
  </div>
);

export const PageHeader = ({ title, subtitle, testId }) => (
  <div className="pt-14 pb-10" data-testid={testId}>
    <h1 className="text-4xl md:text-5xl font-bold text-white tracking-tight" style={{ fontFamily: 'Outfit, sans-serif' }}>
      {title}
    </h1>
    {subtitle && <p className="mt-4 text-slate-400 text-lg max-w-2xl leading-relaxed">{subtitle}</p>}
  </div>
);

export const EmptyState = ({ title, subtitle }) => (
  <div className="sc-card p-12 text-center">
    <div className="w-14 h-14 rounded-full bg-[#1A1D24] border border-[#2A2F3D] flex items-center justify-center mx-auto mb-4">
      <span className="text-2xl text-slate-500">·</span>
    </div>
    <h3 className="text-lg font-semibold text-white mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>{title}</h3>
    <p className="text-sm text-slate-400">{subtitle}</p>
  </div>
);

export default SectionHeader;
